import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import PlaystoreBadge from "../assets/playstore-badge.svg";
import IosBadge from "../assets/appstore-badge.svg";
import { MOBILE_APP_CONFIG } from "../config/constants";
import AppDownloadModal from "./shared/AppDownloadModal";
import { isShareLink } from "@/utils/deepLink";

export default function NotFoundPage() {
    const [searchParams] = useSearchParams();
    const [showModal, setShowModal] = useState(false);

    // Check if this is a share link on mount
    useEffect(() => {
        if (isShareLink(searchParams)) {
            // Show modal if coming from a share link
            setShowModal(true);
        }
    }, [searchParams]);

    return (
        <>
            <div className="flex flex-col items-center justify-center h-[calc(100dvh-75px)] md:h-[calc(100dvh-85px)] ">
                <h1 className='text-[212px] xl:text-[350px] font-lobster text-[#16783A] tracking-[-0.1337px] xl:tracking-[-0.2201px] leading-[177px] xl:leading-[258px]  ' >404</h1>
                <h3 className='font-lexend text-[24px] xl:text-[40px] mt-3 xl:mt-6 text-[#000000] font-semibold ' >Page Not Found</h3>
                <p className='font-lexend text-[15px] xl:text-[20px]  mb-3 xl:mb-6  font-light text-[#000000]  ' >Oops! the page you are looking for does not exist</p>
                <div className="flex items-center gap-4 xl:gap-6">
                    <a href={MOBILE_APP_CONFIG.APP_STORE.ANDROID} aria-label="Get it on Google Play" className="h-[49px] xl:h-[70px] w-fit xl:w-[236px] inline-flex items-center justify-center">
                        <img src={PlaystoreBadge} alt="Get it on Google Play" className="h-full xl:h-[70px] w-full xl:w-auto" />
                    </a>
                    <a href={MOBILE_APP_CONFIG.APP_STORE.IOS} aria-label="Download on the App Store" className="h-[49px] xl:h-[70px] w-[148px] xl:w-[210px] inline-flex items-center justify-center">
                        <img src={IosBadge} alt="Download on the App Store" className="h-full xl:h-[70px] w-full xl:w-auto" />
                    </a>
                </div>
            </div>


            <AppDownloadModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                title="Content Not Available on Web"
                description="This content is only available in our mobile app. Download the Auqli app to view it!"
            />
        </>
    );
}